import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
type MascotProps = {
  src: string;
  alt: string;
};
export function Mascot({
  src,
  alt
}: MascotProps) {
  const reduceMotion = useReducedMotion();
  return <div className="relative mx-auto w-full max-w-[260px] sm:max-w-[320px] lg:max-w-[420px]" data-id="element-192" data-mp="1ysjrm5un0slx">
      <motion.div initial={{
      opacity: 0,
      scale: 0.6,
      y: 10
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      delay: 0.6,
      type: 'spring',
      stiffness: 260,
      damping: 16
    }} className="absolute -top-2 right-0 z-10 sm:-top-4 sm:-right-2" data-id="element-193" data-mp="23r4rg45z9a9u">
        <div className="relative rounded-2xl bg-white px-5 py-2.5 font-display text-2xl font-semibold text-forest shadow-[0_12px_30px_-10px_rgba(0,0,0,0.5)] sm:text-3xl" data-id="element-194" data-mp="2hkmalnur4kzc">
          Hi!
          <motion.span aria-hidden="true" className="ml-1.5 inline-block origin-[70%_80%]" animate={reduceMotion ? undefined : {
          rotate: [0, 18, -8, 18, 0]
        }} transition={{
          duration: 1.4,
          repeat: Infinity,
          repeatDelay: 1.2,
          ease: 'easeInOut'
        }} data-id="element-195" data-mp="164xkinm7b5ub">
            👋
          </motion.span>
          <span aria-hidden="true" className="absolute -bottom-2 left-6 h-4 w-4 rotate-45 bg-white" data-id="element-196" data-mp="fa913xt4w7x4" />
        </div>
      </motion.div>

      <motion.div className="origin-bottom" initial={{
      opacity: 0,
      y: 24
    }} animate={reduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 1,
      y: [0, -6, 0],
      rotate: [0, -2.5, 2.5, -1.5, 0]
    }} transition={{
      opacity: {
        duration: 0.6
      },
      y: {
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      },
      rotate: {
        duration: 2.6,
        repeat: Infinity,
        repeatDelay: 0.6,
        ease: 'easeInOut'
      }
    }} data-id="element-197" data-mp="aawdhaufuwth">
        {src ? <img src={src} alt={alt} className="h-auto w-full object-contain drop-shadow-[0_24px_30px_rgba(0,0,0,0.45)]" data-id="element-198" data-mp="17zpqemlgj8p4" /> : <div role="img" aria-label="Mascot image placeholder" className="flex aspect-square w-full flex-col items-center justify-center gap-3 rounded-full border-2 border-dashed border-white/50 bg-black/20 text-white/80 backdrop-blur-sm" data-id="element-199" data-mp="n89ih5cp05r">
            <ImageIcon className="h-10 w-10" aria-hidden="true" data-id="element-200" data-mp="eeddtwjnygmf" />
            <span className="px-8 text-center text-sm font-semibold" data-id="element-201" data-mp="efog1rxgngbf">Mascot image goes here</span>
          </div>}
      </motion.div>
    </div>;
}